// extracted by mini-css-extract-plugin
export default {"video":"video_video__FNJBx","video__content":"video_video__content__CO80z","video__title":"video_video__title__AupdR","video__buttons":"video_video__buttons__xrJ3-"};